"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberInput = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const utils_1 = require("@obvio/utils");
const react_1 = require("react");
const utils_2 = require("./utils");
const aria_1 = require("./utils/aria");
const components_1 = require("./utils/InputElement/components");
const floatParser = (value, precision) => Number(Number.parseFloat(value).toFixed(precision));
const valueParser = (precision) => (ev) => floatParser(ev.target.value, precision);
const toString = (v, precision) => Number.isNaN(v) ? '' : v.toFixed(precision).replace(/\.0.$/gu, '');
const escapeNaN = (value) => String(Number.isNaN(value) ? '' : value);
const NumberInputElem = (0, react_1.forwardRef)((_a, ref) => {
    var { hasError, success, value, label, onFocus, onBlur, onChange, min, max, prefix, suffix, className, precision = 0, optional } = _a, props = __rest(_a, ["hasError", "success", "value", "label", "onFocus", "onBlur", "onChange", "min", "max", "prefix", "suffix", "className", "precision", "optional"]);
    const [localValue, setLocalValue] = (0, react_1.useState)(escapeNaN(value));
    const id = (0, app_1.useCuid)();
    const [focus, setFocus] = (0, react_1.useState)(false);
    const disabled = Boolean(props.disabled);
    const parser = valueParser(precision);
    if (toString(Number(escapeNaN(value)), precision) !==
        toString(Number(localValue), precision)) {
        setLocalValue(escapeNaN(value));
    }
    const handleChange = (ev) => {
        let parsed = ev.target.value
            .replaceAll(',', '.')
            .replace(/^\./u, '0.')
            .replace(/(\d)|(\.)|./gu, '$1$2');
        const dotIndex = parsed.indexOf('.');
        if (dotIndex >= 0) {
            parsed = parsed.replaceAll('.', '');
            parsed = `${parsed.slice(0, dotIndex)}.${parsed.slice(dotIndex)}`;
        }
        setLocalValue(parsed);
        onChange(floatParser(parsed, precision));
    };
    const handleBlur = (ev) => {
        let v = parser(ev);
        if (!Number.isNaN(v) &&
            (typeof min === 'number' || typeof max === 'number')) {
            v = (0, utils_1.minmax)(v, min, max);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(v);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(v);
        setLocalValue(String(v));
        setFocus(false);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [!!label && ((0, jsx_runtime_1.jsx)(utils_2.Label, Object.assign({ htmlFor: id, inputKind: "text", className: (0, utils_1.cls)({
                    'focus-visible': focus,
                    'with-value': Boolean(value) || value === 0,
                }), optional: Boolean(optional) }, (0, aria_1.aria)({ invalid: hasError, success, disabled }), { children: label }))), (0, jsx_runtime_1.jsx)(utils_2.InputWrapper, Object.assign({ prefix: prefix, suffix: suffix }, (0, aria_1.aria)({ invalid: hasError, success, disabled }), { className: (0, utils_1.cls)({ 'focus-visible': focus }, className) }, { children: (0, jsx_runtime_1.jsx)(components_1.InputInner, Object.assign({}, props, { ref: ref, id: id, onChange: handleChange, onFocus: (ev) => {
                        onFocus === null || onFocus === void 0 ? void 0 : onFocus(parser(ev));
                        setFocus(true);
                    }, onBlur: handleBlur, value: localValue }, (0, aria_1.aria)({ invalid: hasError, success, disabled }))) }))] }));
});
exports.NumberInput = (0, react_1.forwardRef)((_a, ref) => {
    var { defaultValue } = _a, props = __rest(_a, ["defaultValue"]);
    return ((0, jsx_runtime_1.jsx)(utils_2.InputController, Object.assign({}, props, { render: NumberInputElem, defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : Number.NaN, ref: ref })));
});
